import { assign } from 'xstate';

import { openGameInHybrid888App } from '@/components/GameLink/openGameInHybrid888App';
import { openInNewWindow } from '@/components/GameLink/openInNewWindow';
import {
  controllersComponentsMapper,
  controllersEnum,
  removeSpecificControllers,
} from '@/logic/controllers';
import { LogicContext } from '@/logic/main/types';
import { mapUrl } from '@/logic/main/utils';
import { gameLaunchModel } from '@/model/game';

export const createGameLaunchActions = () => {
  const actions = {
    openGameInCurrentTab: (context: LogicContext, event: any) => {
      gameLaunchModel.openGameInCurrentTab(
        event.data.gameToLaunch.launchUrl,
        context.deviceInfo.deviceType,
        context.deviceInfo.deviceOs
      );
    },

    removeGameLaunchController: assign((context: LogicContext) => {
      return {
        ...context,
        controllersData: removeSpecificControllers(
          context.controllersData,
          controllersComponentsMapper[controllersEnum.GAME_LAUNCHER]
        ),
      };
    }),

    openGameInHybrid: (context: LogicContext, event: any) => {
      const gameToLaunch = event.data?.gameToLaunch || context.gameToLaunch;
      if(!gameToLaunch) return;
      const url = mapUrl(gameToLaunch.launchUrl,
        context.deviceInfo.deviceType,
        context.deviceInfo.deviceOs);
      openGameInHybrid888App(url, gameToLaunch.integration === 'virtuefusion');
    },

    openGameInNewWindow: (context: LogicContext, event: any) => {
      const gameToLaunch = event.data?.gameToLaunch || context.gameToLaunch;
      if(!gameToLaunch) return;
      const url = mapUrl(gameToLaunch.launchUrl,
        context.deviceInfo.deviceType,
        context.deviceInfo.deviceOs);
      const result = openInNewWindow(url);
      // if for what ever reason window open is blocked redirect to details page, so user can click and open game
      if (result === null) {
        window.location.href = gameToLaunch.gameDetailsPath;
      }
    }
  };

  return actions;
};
